import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import "./index.css";
import "animate.css";
import { store } from "./store";
import { App } from "./App";
import { getEnvVariables } from "./helpers";

const { REACT_APP_NODE_ENV } = getEnvVariables();

if (REACT_APP_NODE_ENV === "production") {
  const amplifyconfig = require("./amplifyconfiguration.prod.json");
  Amplify.configure(amplifyconfig);
} else {
  const amplifyconfig = require("./amplifyconfiguration.json");
  Amplify.configure(amplifyconfig);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();

// Register service worker (PWA): register in production, unregister in dev
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}
